import { Grid, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { useRef, useState } from "react";
import { ContactForm, ContactFormValues } from "../../components/ContactForm";
import { ContributionCalculator } from "../../components/Contribution/ContributionCalculator";
import { Layout } from "../../components/Layout";
import { extraordinaryColors } from "../../utils/theme";
import { StyledButton } from "../gift-card/GiftCard";

export interface ContributionResult {
  contribution: number;
  annualPlatformFee: number;
  totalContribution: number;
  totalLoadFee: number;
  unspentFundsSaved: number;
  trueTotalCost: number;
}

export const Contribution = () => {
  const contactFormikRef = useRef<FormikProps<ContactFormValues>>();
  const [showResult, setShowResult] = useState(false);

  const handleSubmit = () => {
    if (!contactFormikRef.current) return;
    contactFormikRef.current.handleSubmit();
  };

  return (
    <Layout>
      <Grid item xs={12} mb={10} paddingLeft="24px">
        <Typography variant="h2">Annual Contribution Calculator</Typography>
      </Grid>

      {!showResult ? (
        <>
          <Grid container mb={4} paddingLeft="24px" spacing={6}>
            <Grid item xs={12} textAlign="left">
              <ContactForm
                ref={contactFormikRef}
                webflowSlug="annual-contribution-calculator"
                color={extraordinaryColors.purple.main}
                headingColor="black"
                onSuccess={() => setShowResult(true)}
              />
            </Grid>

            {!showResult && (
              <Grid container justifyContent="flex-end" mt={3}>
                <Grid item>
                  <StyledButton
                    backgroundcolor={extraordinaryColors.purple.main}
                    onClick={() => handleSubmit()}
                  >
                    Continue
                  </StyledButton>
                </Grid>
              </Grid>
            )}
          </Grid>
        </>
      ) : (
        <Grid container spacing={5} paddingLeft="24px">
          <ContributionCalculator />
        </Grid>
      )}
    </Layout>
  );
};
